export default {"src":"/_next/static/image/public/images/logo.905289da95e2f0f1fe3298340dec9c04.svg","height":155,"width":182};